//
// ===== File app.config.ts
//
'use strict';

import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { NgOption } from '@ng-select/ng-select';

export const version = '2.02';
export const languages: Array<string> = ['cs', 'en', 'de'];
export const mceConfig = {
    toolbar: 'undo redo | styleselect | bold italic underline | link unlink | alignleft aligncenter alignright alignjustify | forecolor | '
    + 'bullist numlist | table | cut copy paste | 7upload image 7media | 7frame | 7buttons | removeformat | code',
    plugins: ['textcolor, code, table, image, 7upload, link, 7media, 7buttons, lists'],
    skinUrl: '/assets/tinymce/skins/lightgray',
    langUrl: '/assets/tinymce/locale/cs.js',
    menuBar: false,
    statusBar: true,
    elementpath: false,
    branding: false,
    filePickerTypes: 'image',
    relativeUrls: true,
    removeScriptHost: false,
    convertUrls: true,
    mediaAltSource: false,
    mediaPoster: false,
    mediaDimensions: false,
    imageCaption: true
};
export const textareaDefaultHeight = 120;
export const apiUrl = 'https://api.prefa-technology.cz/';
export const frontUrl = 'https://prefa-technology.cz/';
export const mediaFolder = 'storage/';
export const authTokenKey = 'logged_user';
export const dropzoneConfig: DropzoneConfigInterface = {
    // Change this to your upload POST address:
    url: apiUrl + 'files',
    maxFilesize: 10
};
export const modules = {
    realEstate: false,
    appointments: false,
    bookings: false
};

export const estateTypeOptions: Array<NgOption> = [
    { text: 'Byt', value: 'flat' },
    { text: 'Dům', value: 'house' },
    { text: 'Obchodní prostory', value: 'commercial' },
    { text: 'Pozemek', value: 'land' },
    { text: 'Garáž', value: 'garage' }
];

export const estateMaterialOptions: Array<NgOption> = [
    { text: 'Cihla', value: 'brick' },
    { text: 'Panel', value: 'panel' },
    { text: 'Dřevo', value: 'wood' },
    { text: 'Jiné', value: 'other' }
];

export const estateEnergyOptions: Array<NgOption> = [
    { text: 'A', value: 'A' },
    { text: 'B', value: 'B' },
    { text: 'C', value: 'C' },
    { text: 'D', value: 'D' },
    { text: 'E', value: 'E' },
    { text: 'F', value: 'F' },
    { text: 'G', value: 'G' }
];

export const estateStateOptions: Array<NgOption> = [
    { text: '', value: '' },
    { text: 'Nový', value: 'new' },
    { text: 'Rezervace', value: 'reserved' },
    { text: 'Prodáno', value: 'sold' }
];
